var map = {
	"./47.png": "d0f3",
	"./aceite.png": "0d19",
	"./barra energetica.png": "97c7",
	"./belleza.png": "1e87",
	"./capsula, tableta, gragea, comprimido, perla, pastilla, gomita.png": "9f3e",
	"./champu vaginal.png": "955d",
	"./champu.png": "6440",
	"./chicle, dulce o paleta de caramelo.png": "b021",
	"./crema corporal.png": "7cbb",
	"./crema o unguento oftalmico.png": "4b2f",
	"./crema vaginal.png": "1384",
	"./crema y ovulos vaginales.png": "d350",
	"./crema, pomada, gel, pasta o unguento dermico.png": "5b13",
	"./desodorante perfumado.png": "c991",
	"./dispositivo inhalador polvo.png": "5ad8",
	"./dispositivo inhalador spray.png": "4f06",
	"./dispositivo medico.png": "87d4",
	"./emulsion.png": "bd17",
	"./gotas o spray nasal.png": "e647",
	"./gotas oftalmicas.png": "bb67",
	"./gotas orales.png": "c3dd",
	"./gotas oticas.png": "c0a9",
	"./granulado sobres.png": "1ff0",
	"./granulado.png": "653b",
	"./inyectable en frasco ampula o ampoyeta.png": "b2ac",
	"./jabon en barra.png": "1597",
	"./jalea, miel o pulpa.png": "1bf7",
	"./material de curacion, botiquin.png": "d5cc",
	"./ortopedia.png": "ef46",
	"./ovulos o tabletas vaginales.png": "32f7",
	"./parche medicado.png": "0653",
	"./pasta dental.png": "8f9a",
	"./pieza.png": "1f0a",
	"./polvo sobres.png": "3d86",
	"./polvo.png": "e1bb",
	"./solucion bucofaringea.png": "67aa",
	"./solucion dermica.png": "d68b",
	"./solucion endovenosa.png": "46b9",
	"./solucion o aceite ingerible en ampoyeta.png": "333d",
	"./solucion o jabon liquido dermico.png": "eb44",
	"./solucion para nebulizacion.png": "020f",
	"./solucion rectal.png": "9d3f",
	"./solucion vaginal.png": "acf9",
	"./spray bucofaringeo.png": "e550",
	"./spray dermico.png": "c83a",
	"./supositorio rectal.png": "1122",
	"./suspension, jarabe, solucion,elixir, liquido.png": "a003",
	"./tableta efervecente o dispersable.png": "09b1",
	"./tableta sublingual u orodispersable.png": "359c",
	"./talco o polvo dermico.png": "d474"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2220";